import { render, staticRenderFns } from "./QuoteClient.vue?vue&type=template&id=084103fd&scoped=true"
import script from "./QuoteClient.vue?vue&type=script&lang=ts"
export * from "./QuoteClient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_css-loader@6.11.0_webpack@5.106.2__ejs@3.1._76e9b4b2772e69f80f08b9c9843f568a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084103fd",
  null
  
)

export default component.exports